/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_hplc_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scale HPLC flow, injection and gradient when changing column dimensions.`)
};

const es_hplc_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escala el flujo, la inyección y el gradiente de HPLC al cambiar las dimensiones de la columna.`)
};

const de_hplc_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skalieren Sie Fluss, Injektion und Gradient bei einem HPLC-Säulenwechsel.`)
};

const nl_hplc_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schaal HPLC-flow, injectie en gradiënt bij het wijzigen van kolomafmetingen.`)
};

const fr_hplc_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adaptez le débit, l'injection et le gradient HPLC lors d'un changement de dimensions de colonne.`)
};

const it_hplc_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scala flusso, iniezione e gradiente HPLC quando cambiano le dimensioni della colonna.`)
};

const pt_br2_hplc_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dimensione o fluxo, a injeção e o gradiente de HPLC ao alterar as dimensões da coluna.`)
};

const pt_hplc_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escale o fluxo, a injeção e o gradiente de HPLC ao mudar as dimensões da coluna.`)
};

const ja_hplc_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`カラム寸法を変更する際に、HPLCの流速、注入量、グラジエントをスケーリングします。`)
};

const zh_hplc_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在更换色谱柱规格时，放大 HPLC 流速、进样量和梯度时间。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const hplc_tool_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.hplc_tool_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("hplc_tool_description", locale)
	if (locale === "en") return en_hplc_tool_description(inputs)
	if (locale === "es") return es_hplc_tool_description(inputs)
	if (locale === "de") return de_hplc_tool_description(inputs)
	if (locale === "nl") return nl_hplc_tool_description(inputs)
	if (locale === "fr") return fr_hplc_tool_description(inputs)
	if (locale === "it") return it_hplc_tool_description(inputs)
	if (locale === "pt-BR") return pt_br2_hplc_tool_description(inputs)
	if (locale === "pt") return pt_hplc_tool_description(inputs)
	if (locale === "ja") return ja_hplc_tool_description(inputs)
	return zh_hplc_tool_description(inputs)
};